const styles = {
  wrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    paddingBottom: -30,
  },
  title: {
    color: '#273754',
    fontSize: 18,
  },
  blockLeft: {
    height: '100%',
    padding: '34px 55px 0 64px',
    borderRight: '1px solid #E9E9E9',
  },
  blockRight: {
    height: '100%',
    padding: '34px 50px 0 50px',
  },
  uploadItemsWrapper: {
    borderRadius: 4,
    width: '100%',
    border: '0.7px solid #D8D8D8',
    margin: '10px 0 24px 0',
    '& > div': {
      borderBottom: '0.7px solid #D8D8D8',
    },
    '& > div:last-child': {
      borderBottom: 'none',
    },
  },
  uploadWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    padding: 17,
    background: '#F8F8F8',
  },
  uploadTitle: {
    color: '#363636',
    fontSize: '13px',
    fontWeight: 800,
  },
  uploadSubtitle: {
    color: '#363636',
    fontSize: '12px',
    fontWeight: 400,
  },
  button: {
    height: 28,
    width: 100,
    fontSize: 12,
    marginLeft: 20,
  },
  buttonWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
  },
  success: {
    background: '#E5F7E1',
  },
  off: {
    opacity: '0.5',
  },
  error: {
    color: '#FF0000',
  },
}

export { styles }
